var _path, _path2, _path3, _path4, _path5, _path6;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 42,
    height: 48,
    viewBox: "0 0 42 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.67407 10.4214L19.7239 21.301V0.0195312L15.7776 2.28013V14.593L9.30651 10.6001L13.0353 8.24237V3.861L1.67407 10.4214Z",
    fill: "#F4E096"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M40.1703 36.694L22.272 25.8843V47.0259L26.1834 44.7692V32.5923L32.6544 36.5813L28.9256 38.939V43.1845L40.1703 36.694Z",
    fill: "#F4E096"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M37.0241 8.51415L26.0746 14.6589V6.90998L30.2423 9.39586L34.2625 6.92163L22.272 0V21.3126L40.516 10.5339L37.0241 8.51415Z",
    fill: "#F4E096"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M5.11906 38.5934L15.921 32.534V40.2869L11.7533 37.801L7.87684 40.1859L19.7236 47.0259V25.8843L1.62329 36.5775L5.11906 38.5934Z",
    fill: "#F4E096"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M42 13.1831V26.5758L38.2673 24.4007V19.5687L34.0529 21.9458L31.2524 23.5228L38.2673 27.609L42 29.7841V34.1849L27.4148 25.6863L23.6821 23.5112L25.9777 22.2177L27.5197 21.3477L30.3163 19.7707L38.2673 15.2883L42 13.1831Z",
    fill: "#F4E096"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M0 34.1849V20.7922L3.73271 22.9674V27.7993L7.94706 25.4222L10.7476 23.8452L3.73271 19.759L0 17.5839V13.1831L14.5851 21.6817L18.3179 23.8569L16.0223 25.1503L14.4803 26.0204L11.6837 27.5973L3.73271 32.0797L0 34.1849Z",
    fill: "#F4E096"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.92944bd4e357724ec9fca651050796ea.svg";
export { ForwardRef as ReactComponent };